import {DELETE_SLEEVE} from "../constants/constants";

export const deleteSleeveToSide = (data) => {
    return {
        type : DELETE_SLEEVE,
        payload : {...data}
    }
};


// WEBPACK FOOTER //
// ./src/actions/deleteSleeveToSide.js